import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataUser(params) {
	return clientSupplier.get("api-supplier/user/data", {
		params: params,
	});
}

function exportUser(params) {
	return clientSupplier.get("api-supplier/user/export", {
		params: params,
	});
}

function addUser(params) {
	return clientSupplier.post("api-supplier/user/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateUser(params) {
	return clientSupplier.post("api-supplier/user/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteUser(params) {
	return clientSupplier.post("api-supplier/user/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusUser(params) {
	return clientSupplier.post("api-supplier/user/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changeImage(params) {
	return clientSupplier.post('api-supplier/user/image', params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function changePassword(params) {
	return clientSupplier.post("api-supplier/user/edit-password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataUser,
	exportUser,
	addUser,
	updateUser,
	deleteUser,
	statusUser,
	changeImage,
	changePassword,
};